import styled from 'styled-components';

import THEME from '../../../constants/theme';

interface RightSideBarProps {
  isHidden?: boolean;
  isOpen?: boolean;
}

interface ButtonProps {
  disabled?: boolean;
}

export const ActionsContainer = styled.div.attrs({
  className: 'ActionsContainer',
})`
  background: #192225;
  border-radius: 5px;
`;

export const Button = styled.div.attrs({
  className: 'Button',
})<ButtonProps>(
  ({ disabled }) => `
    background: ${disabled ? 'none' : '#222'};
    color: ${disabled ? '#999' : '#ccc'};
    border-radius: 5px;
    height: 32px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${disabled ? 'default' : 'pointer'};
    &:hover {
      background: ${disabled ? 'none' : '#444'};;
    }
    > a {
      all: unset;
      display: flex;
      gap: 0.5em;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
    }
  `
);

interface CanvasContainerProps {
  isHidden?: boolean;
}

export const CanvasContainer = styled.div.attrs({
  className: 'CanvasContainer',
})<CanvasContainerProps>(
  ({ isHidden }) => `  
    display: ${isHidden ? 'none' : 'flex'};
    flex-direction: column;
    height: 100%;
    width: 100%;
    gap: 10px;
    > div { 
      flex-grow: 1;
    }
  `
);

export const PageContainer = styled.div.attrs({
  className: 'PageContainer',
})`
  height: calc(100% - 60px);
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ContentContainer = styled.div.attrs({
  className: 'ContentContainer',
})`
  height: calc(100% - 100px);
  display: flex;
  wdith: 100%;
  gap: 10px;
`;

export const HeaderContainer = styled.div.attrs({
  className: 'HeaderContainer',
})`
  width: 100%;
  background: #192225;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
  height: 60px;
  position: relative;
`;

export const ReviewFrameHeader = styled.div.attrs({
  className: 'ReviewFrameHeader',
})`
  position: absolute;
  left: 50%;
  max-width: 40%;
  transform: translateX(-50%);
  overflow: hidden;
  color: white;
  font-weight: bold;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface IconContainerProps {
  isHidden?: boolean;
  size?: number;
}

export const IconContainer = styled.div.attrs({
  className: 'IconContainer',
})<IconContainerProps>(
  ({ isHidden, size }) => `
    height: 100%;
    width: 100%;
    display: ${isHidden ? 'none' : 'flex'};
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow-y: auto;
    // background: #192225;
    gap: 10px;
    border-radius: 5px;
    overflow: hidden;
    > div {
      // flex-grow: 1;
      justify-content: center;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    > svg {
      width: ${size}px;
      height: ${size}px;
      stroke: ${isHidden ? 'none' : '#666'} !important;       
    }
  `
);

export const LabelsContainer = styled.div.attrs({
  className: 'LabelsContainer',
})`
  display: flex;
  gap: 5px;
`;

interface LabelTagProps {
  type?: string;
}

export const LabelTag = styled.div.attrs({
  className: 'LabelTag',
})<LabelTagProps>(
  ({ type }) => `  
    background: ${
      type === 'identifier'
        ? THEME.identifier
        : type === 'phaser'
          ? THEME.variant6
          : type === 'keypointer'
            ? THEME.keypoints
            : type === 'segmentor'
              ? THEME.segmentations
              : THEME.variant8
    };
    color: white;
    border-radius: 5px;
    height: 32px;
    width: ${type === 'identifier' ? 137 : 100}px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: 12px;
    padding: 5px;
    cursor: ${type === 'type' ? 'pointer' : 'default'};
    hover: {
      opacity: ${type === 'type' ? 0.9 : 1};
    }
  `
);

export const RightSideBar = styled.div.attrs({
  className: 'RightSideBar',
})<RightSideBarProps>(
  ({ isHidden, isOpen }) => `  
    // display: ${isHidden ? 'none' : 'flex'};
    display: flex;
    // height: 75.5vh;
    width: ${isOpen ? 300 : 100}px;
    min-width: ${isOpen ? 300 : 100}px;
    flex-direction: column;
    // overflow-y: auto;
    // background: #192225;
    // gap: 10px;
    border-radius: 5px 0 0 5px;
    transition: 0.25s;
    position: relative;
  `
);

export const SideBarContainer = styled.div.attrs({
  className: 'SideBarContainer',
})`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background: #222;
  gap: 10px;
  border-radius: 0 0 5px 5px;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  > div {
    justify-content: center;
  }
`;

export const SmallLoaderContainer = styled.div.attrs({
  className: 'SmallLoaderContainer',
})`
  height: 32px;
  width: 40px;
  margin-right: -15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface StatusTagProps {
  isHidden?: boolean;
  isLabeled?: boolean;
  isSkipped?: boolean;
}

export const StatusTag = styled.div.attrs({
  className: 'StatusTag',
})<StatusTagProps>(
  ({ isHidden, isLabeled, isSkipped }) => `  
    background: ${isLabeled ? 'green' : isSkipped ? 'red' : 'none'};
    color: ${isLabeled || isSkipped ? 'white' : 'none'};
    border-radius: 5px;
    height: 32px;
    width: 100px;
    padding: 0 10px;
    display: ${isHidden ? 'none' : 'flex'};
    align-items: center;
    justify-content: center;
  `
);

export const LeftSideHeaderContainer = styled.div.attrs({
  className: 'LeftSideHeaderContainer',
})`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StudyIdContainer = styled.div.attrs({
  className: 'StudyIdContainer',
})`
  color: white;
  float: left;
  margin-left: 10px;
`;

export const Title = styled.div.attrs({
  className: 'Title',
})`
  font-size: 1.5em;
  width: 100%;
  text-align: center;
`;

export const ViewerContainer = styled.div.attrs({
  className: 'ViewerContainer',
})`
  background: black;
  height: calc(100vh - 60px);
  width: 100%;
  margin-top: 60px;
`;

interface TabProps {
  isActive?: boolean;
}

export const Tab = styled.div.attrs({
  className: 'Tab',
})<TabProps>(
  ({ isActive }) => `  
    background: ${isActive ? '#222' : '#161616'};
    color: #ccc;
    border-radius: 5px 5px 0 0;
    height: 32px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex: 1;
    &:hover {
      background: #222;
    }
  `
);

export const TabContainer = styled.div.attrs({
  className: 'TabContainer',
})`
  display: flex;
  gap: 5px;
  width: 100%;
`;
